import { redirect, type RouteObject } from 'react-router';
import { paths } from '@/app/router/paths';

/** / (public) */
export const landingRoutes: RouteObject = {
  index: true,
  lazy: () => import('./LandingPage').then((m) => ({ Component: m.LandingPage })),
};

/** /home → / (legacy alias for the landing page) */
export const homeRedirectRoutes: RouteObject = {
  path: paths.home,
  loader: () => redirect(paths.landing),
};
